<template>
  <div
    :class="$style.btnRefresh"
    :aria-label="$t('global.refresh')"
    tabindex="0"
    type="role"
    @click="clickHandler"
  >
    <img
      :class="$style.img"
      src="@/assets/images/icons/navigation/refresh.svg"
      :title="$t('global.refreshData')"
      :alt="$t('global.refreshData')"
    >
    <p
      v-if="text"
      :class="$style.text"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
  export default {
    props: ['text'],
    methods: {
      clickHandler() {
        this.$emit('click');
      },
    },
  };
</script>

<style lang="scss" module>
  .btnRefresh {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .text {
    color: $black;
    font-size: 15px;
    line-height: 18px;
    margin-left: 10px;
  }
  .img {
    min-width: 15px;
  }
</style>
